import React, { useState } from 'react';
import { Tag, Row, Spin, Button } from 'antd';
import PaginationTable from '../../../shared/PaginationTable';

const InvoiceView = (props) => {
  let { invoiceList, loading, invoiceFilterList } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    {
      title: 'Invoice #',
      dataIndex: 'invoice_number',
      key: 'invoiceNum',
    },
    {
      title: 'Due Date',
      dataIndex: 'dueDate',
      key: 'dueDate',
      sorter: (a, b) => new Date(a.dueDate) - new Date(b.dueDate),
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Description',
      dataIndex: 'title',
      key: 'title',
      width: '30%',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      className: 'column-money',
      align: 'right',
      width: '120px',
    },
    {
      title: 'Balance',
      dataIndex: 'balance',
      key: 'bal',
      className: 'column-money',
      align: 'right',
      width: '120px',
    },
    {
      title: 'Days overdue',
      dataIndex: 'overdue',
      key: 'overdue',
      width: '120px',
      render: (text, invoiceFilterList) => (
        <span style={{ color: 'red' }}>{invoiceFilterList.overdue}</span>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: '140px',
      render: (text, invoiceFilterList) => (
        <span>
          <Tag
            color={
              invoiceFilterList.status === 'PAID'
                ? 'green'
                : invoiceFilterList.status === 'SCHEDULED'
                  ? 'blue'
                  : 'volcano'
            }
          >
            {invoiceFilterList.status}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: '80px',
      render: (text, invoiceFilterList) => (
        <div
          style={
            invoiceFilterList.status === 'PAID' ||
            invoiceFilterList.status === 'SCHEDULED' ||
            invoiceFilterList.status === 'CANCELED' ||
            invoiceFilterList.status === 'REFUNDED'
              ? { display: 'none' }
              : null
          }
        >
          <Button
            type="primary"
            onClick={() => window.open(invoiceFilterList.public_url, '_blank')}
            size="small"
          >
            PAY
          </Button>
        </div>
      ),
    },
  ];

  const table = (
    <>
      <PaginationTable
        // footer={medias && medias.slice(currentPage * 10 - 10, currentPage * 10)}
        bordered={false}
        columns={columns}
        data={invoiceFilterList}
        scroll={{ x: 800, y: 600 }}
        paginationSize={'default'}
        size={'default'}
        total={invoiceFilterList && invoiceFilterList.length}
        current={currentPage}
        pageSize={pageSize}
        onChange={(paginationObject, filtersObject, sorterObject) => {
          setPageSize(paginationObject.pageSize);
          setCurrentPage(paginationObject.current);
        }}
      />
    </>
  );
  if (loading) {
    return (
      <Row type="flex" justify="center" align="middle">
        <Spin size="large" />
      </Row>
    );
  } else {
    return invoiceList && invoiceList.length ? table : null;
  }
};

export default InvoiceView;
